export default "__VITE_ASSET__CsfZe7r2__"